import { useCallback } from 'react';
import { useWebgate } from '@xvia/webgate-connect';
import { redirectToService as redirectToServiceUtil } from '../util/service-redirect';

export const useServiceRedirect = () => {
  const { portalConnect } = useWebgate();

  const redirectToService = useCallback(
    (url: string) => {
      redirectToServiceUtil(url, portalConnect);
    },
    [portalConnect]
  );

  return { redirectToService };
};
